import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { Alert, Spin } from 'antd';
import MyRouter from './router/MyRouter';
import { PersistGate } from 'redux-persist/integration/react';

const App = () => {
  return (
    <Alert.ErrorBoundary description="Щось пішло не так. Спробуйте ще раз.">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Suspense fallback={<Spin size={'large'} fullscreen />}>
            <MyRouter />
          </Suspense>
        </PersistGate>
      </Provider>
    </Alert.ErrorBoundary>
  );
};

export default App;
